// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from AddressButtonIcon.module.scss  */
.AddressButtonIcon-module-Root_1d5 {
  cursor: pointer;
  color: #9199a3;
  border: 0;
  background-color: transparent;
  fill: #9199a3; }

.AddressButtonIcon-module-ButtonSvg_3r3 {
  pointer-events: none; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Address/ButtonIcon/AddressButtonIcon.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,6BAA6B;EAC7B,aAAa,EAAE;;AAEjB;EACE,oBAAoB,EAAE","sourcesContent":["/*  imported from AddressButtonIcon.module.scss  */\n.AddressButtonIcon-module-Root_1d5 {\n  cursor: pointer;\n  color: #9199a3;\n  border: 0;\n  background-color: transparent;\n  fill: #9199a3; }\n\n.AddressButtonIcon-module-ButtonSvg_3r3 {\n  pointer-events: none; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
